import { useEffect, useRef } from 'react';
export var usePreviousProp = function usePreviousProp(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};